import {useList} from "@refinedev/core";
import IAuthentication from "../interfaces/IAuthentication";

export const AUTHENTICATIONS_RESOURCE = "authentication"

/**
 * Retrieves the list of authentications.
 *
 * @returns {Object} An object containing the authentications and loading status.
 * @property {Array.<IAuthentication>|undefined} authentications - The list of authentications.
 * @property {boolean} isLoadingAuths - A boolean indicating if the authentications are currently being loaded.
 */
export function getAuthentications() {
    const { data: dataAuthentications, isLoading: isLoadingAuths } = useList<IAuthentication>({
        resource: AUTHENTICATIONS_RESOURCE,
        meta: {
            resourceName:"authentications",
        }
    });
    return { authentications: dataAuthentications?.data, isLoadingAuths };
}
